  <template>
  <div class="tabs">
    <m-btn
      v-for="(item, index) in tabs"
      :key="index"
      class="ml-10"
      :active="index === selected"
      :label="item[label]"
      @click.native="getTabInfo(item, index)"
      mode="btn-1"
    />

  </div>
</template>

<script>
import MBtn from "cp/element/button";
export default {
  name: 'Tabs',
  components: {
    MBtn
  },
  props: {
    label: {
      type:String,
    },
    tabs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selected: 0
    }
  },
  methods: {
    getTabInfo(item, index) {
      this.selected = index
      this.$emit('onClick', item, index)
    }
  }
}
</script>

<style lang="stylus" scoped>

.tabs
  display flex
  justify-content flex-start
  align-self center
  flex-wrap: wrap;
  .ml-10
    margin-left 10px
</style>



// WEBPACK FOOTER //
// src/components/element/tab/index.vue